export class GeographyModel {
  id: Number;
  status: Number;
  geograph_code: String;
  geograph_name: String;
  parent_geo_code: String;
  value_type: String;
}

export class ExcelModel {
  excel_data : any;
}

export class GapExcelModel {
  gap_upload : any;
  gap_input_data: any[];
  gap_file : any[];
}
